import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent, CardMedia, Typography, Link } from '@mui/material';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const NewsCard = ({ title, excerpt, image, url }) => {
  return (
    <Card style={{ width: 330, height: 330, margin: '20px auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Link href={url} target="_blank" rel="noopener" underline="none" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <CardMedia
          component="img"
          height="140"
          image={image}
          alt={title}
        />
        <CardContent style={{ textAlign: 'center' }}>
          <Typography gutterBottom variant="h5" component="div">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="div">
            <span dangerouslySetInnerHTML={{ __html: excerpt }} />
          </Typography>
        </CardContent>
      </Link>
    </Card>
  );
};

const NewsSlider = ({ newsData }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    swipe: true,
    adaptiveHeight: true,
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Slider {...settings} style={{ width: '100%', maxWidth: 600 }}>
        {newsData.slice(0, 5).map((newsItem, index) => (
          <div key={index} style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <NewsCard
              title={newsItem.title}
              excerpt={newsItem.excerpt}
              image={newsItem.image}
              url={newsItem.url}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NewsSlider;
